// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"v9Fw3","hidden":"_29sDF","title":"_1Z7cC","link":"_2izZC"};